import { AVAILABILITY_DOC_ID, AvailabilitySchema, paths, type Availability } from '@acs/shared';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { availabilityConverter, type AvailabilityDoc } from './converters.js';
import { db } from './firebase.js';

export function subscribeAvailability(
  businessId: string,
  cb: (avail: AvailabilityDoc | null) => void,
): () => void {
  const ref = doc(db, paths.availabilityDoc(businessId)).withConverter(availabilityConverter);
  return onSnapshot(ref, (snap) => cb(snap.exists() ? snap.data() : null));
}

/**
 * Written through the schema, not as handed in. Every caller edits the
 * document it READ, and a read comes back through the converter carrying the
 * doc's `id` — spread into the write, that unknown field made the rules refuse
 * it (`writesOnly`), so the wizard's hours step could never be saved. Parsing
 * keeps exactly the schema's fields, whatever the caller spread in.
 */
export async function saveAvailability(businessId: string, availability: Availability): Promise<void> {
  // A calendar-day notice of 0 is written as ABSENT (doc 84): the same thing to
  // every reader (it is the schema default, and this write replaces the whole
  // document), and what the rules deployed before the field existed accept —
  // so saving hours never depends on the rules having shipped first.
  const { minNoticeDays, ...rest } = AvailabilitySchema.parse(availability);
  await setDoc(
    doc(db, `${paths.business(businessId)}/availability/${AVAILABILITY_DOC_ID}`),
    minNoticeDays > 0 ? { ...rest, minNoticeDays } : rest,
  );
}
